import { useWebsitePlans } from '@/services/httpServices/queries/useWebsite'

/**
 * The home page "Plans & Pricing" section. Plans are managed from the dashboard
 * (Website → Plans) and fetched from the API, falling back to the bundled demo
 * content when the API is unreachable. Every active plan is listed in a single
 * flat row — there is no billing-period toggle.
 */
export function PricingPlans() {
  const { plans } = useWebsitePlans()

  return (
    <section className="pricing-section-1 pt-100 md-pt-80 pb-70 md-pb-50">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* section title area start */}
            <div className="section-title-area">
              <div className="section-title">
                <span className="sub-title">Plans &amp; Pricing</span>
                <h2>Choose From Our Health Checkup Packages</h2>
              </div>
              <div className="section-title-content">
                <p>
                  Regular health checkups help detect diabetes, high blood pressure, heart and kidney problems
                  early, when treatment is easiest and most effective. Choose the package that suits your age
                  and health needs.
                </p>
              </div>
            </div>
            {/* section title area end */}
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-12">
            {/* pricing image item start */}
            <div className="pricing-image-item">
              {/* pricing image content start */}
              <div className="pricing-image-content">
                <span>Stay Healthy</span>
                <h3>With Regular Checkups</h3>
                <p>
                  Book your health checkup package at Fast Aid Hospital and get a free follow-up
                  consultation with our physician.
                </p>
                <a href="/contact" aria-label="pricing">
                  <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>
              {/* pricing image content end */}
              {/* pricing image start */}
              <div className="pricing-image text-center">
                <img src="/assets/images/pricing/pricing-1.png" alt="pricing image" />
              </div>
              {/* pricing image end */}
            </div>
            {/* pricing image item end */}
          </div>

          {plans.map((plan) => (
            <div className="col-lg-4 col-md-12" key={plan.id}>
              {/* pricing item start */}
              <div className="pricing-item">
                {/* pricing content start */}
                <div className="pricing-content">
                  {/* pricing text start */}
                  <div className="pricing-text">
                    <p className="pricing-plan-title">
                      {plan.name}
                      {plan.popular ? <span>Popular</span> : null}
                    </p>
                    <h3 className="pricing-plan-price">{plan.price}</h3>
                    {plan.description ? <p>{plan.description}</p> : null}
                  </div>
                  {/* pricing text end */}
                  {/* pricing list start */}
                  <div className="pricing-list">
                    <p className="text-black">What's included?</p>
                    {/* check list start */}
                    <div className="check-list mb-30">
                      <ul>
                        {plan.features.map((feature, index) => (
                          <li key={`${feature}-${index}`}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                    {/* check list end */}
                    {/* pricing button wapper start */}
                    <div className="pricing-button-wapper">
                      <a href="/contact" className="theme-button style-2" aria-label="Choose Plan">
                        <span data-text="Choose Plan">Choose Plan</span>
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                    {/* pricing button wapper end */}
                  </div>
                  {/* pricing list end */}
                </div>
                {/* pricing content end */}
              </div>
              {/* pricing item end */}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
